import {Button, Menu, MenuItem, MenuTrigger, Popover} from "react-aria-components";
import {NavLink} from "react-router-dom";
import {UserIcon} from "@components/Icons/UserIcon";
import {useUser} from "@lib/User/UserHooks";
import {useCmsUserNavigation} from "@store/AppContextStore";
import {buildLinkUrl} from "@router/RouterUtils";
import {useAuth} from "@msal/useAuth";

export function UserMenu() {

    const {
        data: user,
        isLoading: userLoading,
    } = useUser();

    const userNavigation = useCmsUserNavigation();

    const {logoutFull} = useAuth();

    if (userLoading || !user) {
        return null;
    }

    return (
        <MenuTrigger>
            <Button className="userMenu__trigger cta cta--small cta--light cta-account">
                <span className="icon">
                    <UserIcon/>
                </span>
                {!!user && user.name &&
                    <span className={"label"}>{user.name}</span>
                }
            </Button>

            {userNavigation && userNavigation.length > 0 &&
                <Popover className="userMenu__popover" placement="bottom end" offset={8}>
                    <Menu
                        className="userMenu__menu"
                        aria-label="User menu"
                        onAction={(key) => {
                            if (key === "LOGOUT") {
                                void logoutFull();
                            }
                        }}
                    >
                        {userNavigation.map((link, index) => {

                            const key = link.scope ?? `user_link_${index}`;
                            const isLogout = link.scope === "LOGOUT";

                            return (
                                <MenuItem
                                    className="userMenu__item"
                                    key={key}
                                    id={key}
                                >
                                    {isLogout ?
                                        <span className="userMenu__link tp-2xs">{link.title}</span>
                                        :
                                        <NavLink
                                            to={buildLinkUrl(link.scope)}
                                            target={link.href?.target ?? undefined}
                                            className="userMenu__link tp-2xs"
                                        >
                                            {link.title}
                                        </NavLink>
                                    }
                                </MenuItem>
                            );

                        })}
                    </Menu>
                </Popover>
            }
        </MenuTrigger>
    );
}
